import { connect } from 'react-redux'
import FeedbackForm from './FeedbackForm'
import { feedbackCancel, feedbackSubmit } from '../../store/feedback'

const mapStateToProps = (state, ownProps) => ({
  feedback: state.feedback || { }
})

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onCancel: () => {
      dispatch(feedbackCancel())
    },
    onSubmit: (comment, feedbackType) => {
      dispatch(feedbackSubmit(comment, feedbackType))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackForm)



// WEBPACK FOOTER //
// ./src/components/FeedbackForm/index.js